module.exports = __webpack_public_path__ + "img/experience_on.1d19c8b3.svg";